import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["marketplaceSelect"]

  linkClick(e) {
    this.marketplaceSelectTarget.value = e.target.dataset.marketplaceId
  }
}
